import { Button } from '@localagent/ui/components/button';
import type { ExperienceMode } from '@localagent/sdk';

export function ExperienceModeToggle({
  mode,
  onChange,
  disabled = false,
  error = null,
}: {
  mode: ExperienceMode | undefined;
  onChange: (mode: ExperienceMode) => void;
  disabled?: boolean;
  error?: string | null;
}) {
  return (
    <div data-testid="experience-mode-toggle">
      <span className="text-label font-medium text-muted-foreground">User</span>
      <div className="mt-2 flex gap-2">
        <Button
          data-testid="experience-mode-normal"
          variant={mode === 'normal' ? 'default' : 'outline'}
          size="sm"
          disabled={disabled}
          aria-pressed={mode === 'normal'}
          onClick={() => onChange('normal')}
        >
          Normal
        </Button>
        <Button
          data-testid="experience-mode-advanced"
          variant={mode === 'advanced' ? 'default' : 'outline'}
          size="sm"
          disabled={disabled}
          aria-pressed={mode === 'advanced'}
          onClick={() => onChange('advanced')}
        >
          Advanced
        </Button>
      </div>
      {error ? (
        <p className="mt-2 text-body text-destructive" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
